import axiosInstance from "../config/AuthInterceptors";

const utilsService = {
    downloadFileFromMemory: (urlToDownload: string) => {
        return axiosInstance.get(urlToDownload, {
            responseType: 'blob'
        }).then(
            response => {
                const contentDisposition = response.headers['content-disposition'];
                let fileName = 'download.csv';

                if (contentDisposition) {
                    const fileNameMatch = contentDisposition.match(/filename\*?=(?:UTF-8'')?["']?([^;"'\n]+)["']?/i);

                    if (fileNameMatch && fileNameMatch.length > 1)
                        fileName = fileNameMatch[1];
                }

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');

                link.href = url;
                link.setAttribute('download', fileName);

                document.body.appendChild(link);

                link.click();

                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                return "OK";
            },
            (error) => {
                return error
            }
        )
    },
}

export default utilsService; 